export function TableRow(props) {
  return (
    <tr onClick={props.onClick} data-item={props.data}>
      {props.children}
    </tr>
  );
}
